import cn from 'classnames';
import { ReactNode, ChangeEvent } from 'react';

import styles from './Checkbox.module.scss';

export interface ICheckboxProps {
  className?: string;
  labelClassName?: string;
  id?: string;
  name?: string;
  value?: string | number;
  type?: string;
  theme?: 'system' | 'custom';
  size?: 'small' | 'medium';
  label?: ReactNode;
  checked?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  error?: string;
  closeButton?: ReactNode;
  color?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Checkbox = ({
  className = '',
  labelClassName,
  id,
  type = 'checkbox',
  theme = 'custom',
  size = 'small',
  label,
  color,
  error,
  ...rest
}: ICheckboxProps) => {
  const classNames = cn(styles.Checkbox, className, {
    [styles.CheckboxSystem]: theme === 'system',
    [styles.CheckboxCustom]: theme === 'custom',
    [styles.CheckboxSmall]: size === 'small',
    [styles.CheckboxMedium]: size === 'medium',
  });

  return (
    <div className={classNames}>
      <div className={styles.CheckboxBody}>
        <input className={styles.CheckboxInput} id={id} type={type} {...rest} />
        {theme === 'custom' && <label className={styles.CheckboxMark} htmlFor={id} hidden />}
        {label && (
          <label className={cn(styles.CheckboxLabel, labelClassName)} htmlFor={id}>
            {label}
          </label>
        )}
      </div>
      {error && <div className={styles.Error}>{error}</div>}
    </div>
  );
};
